import React from "react";

const BudgetAvailability = ({ stats, available, lineItemTotal, isOver }) => (
  <>
    {stats ? (
      <>
        {stats.totalAllocated != null && (
          <span>Allocated: {Number(stats.totalAllocated).toFixed(2)}</span>
        )}
        {stats.consumed != null && (
          <span>Consumed: {Number(stats.consumed).toFixed(2)}</span>
        )}
        {stats.reservedAmount != null && (
          <span>Reserved: {Number(stats.reservedAmount).toFixed(2)}</span>
        )}
        {stats.availableBudgetCost != null && (
          <span>
            Available:{" "}
            {Number(stats.availableBudgetCost).toFixed(2)}
          </span>
        )}
      </>
    ) : (
      <span>Available Amt: {Number(available).toFixed(2)}</span>
    )}
    <span className={isOver ? "error" : ""}>
      PR Amount: {lineItemTotal.toFixed(2)}
    </span>
  </>
);

export default BudgetAvailability;
